module.exports = __webpack_public_path__ + "static/13.1_the_rise_of_rome-5f09781d0ee84f690939531c344629fc.pdf";